import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
const FeatureRenderer = ({ children, shouldNavigate = false, shouldCheckKyc = true, isAvailable, isKycRequired, isLoading, }) => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!isLoading && shouldCheckKyc && isKycRequired) {
            navigate('/kyc', { replace: true });
        }
    }, [isKycRequired, isLoading, navigate, shouldCheckKyc]);
    useEffect(() => {
        if (!isLoading && !isAvailable && shouldNavigate) {
            navigate('/', { replace: true });
        }
    }, [isAvailable, isLoading, navigate, shouldNavigate]);
    if (isAvailable)
        return _jsx(_Fragment, { children: children });
    return null;
};
export default FeatureRenderer;
//# sourceMappingURL=FeatureRenderer.js.map